import { combineReducers } from 'redux';

import dialogSelectAllDebits from './dialogSelectAllDebits';

const reducer = combineReducers({
  [dialogSelectAllDebits.name]: dialogSelectAllDebits.reducer,
});

export default reducer;
